import { defineCustomElement } from '@tyler-components-web/core';
import { ProfileCardComponent } from './profile-card';
export * from './profile-card-adapter';
export * from './profile-card-constants';
export * from './profile-card-foundation';
export * from './profile-card';
export function defineProfileCardComponent() {
    defineCustomElement(ProfileCardComponent);
}
